import styled from 'styled-components';
import { spacer12, white } from '@spotify-internal/encore-foundation';
export default styled.span.withConfig({
  displayName: "Indicator",
  componentId: "sc-1ncuwu7-0"
})(["background:", ";border-radius:inherit;height:", ";left:2px;position:absolute;top:2px;width:", ";transition:all 0.1s ease;"], white, spacer12, spacer12);